import React, { useEffect, useState } from "react";
import { Row, Col } from "react-grid-system";
import { ISelectLabel } from "@ds/ds-snam/dist/models/select";
import { IRadioButton } from "@ds/ds-snam/dist/models/radioButton";
import { ClientTypes, ClientType, IClientTypeData } from "shared/constants";
import { ICustomer } from "dataModels/contract";
import { Select, Input as TextInput } from "@ds/ds-snam/react";
import { RadiobuttonList } from "@ds/ds-snam/react";
import { useTranslation } from "react-i18next";
import { dsDeselectHandler, dsSelectHandler } from "shared/utils/dsComponentUtils";
import { myCountryArraySelect, myCountryArraySelectEN, provinceMap } from "shared/domains/formDomains";


interface INewCustomerFormDataInputProps {
    formData: ICustomer,
    onTextInputChange: (inputEvent: Event) => void,
    onSelectInputChange: (inputEvent: Event,fieldName:string) => void,
    onRadioChange: (inputEvent: Event) => void
}
const CustomerFormDataInput: React.FC<INewCustomerFormDataInputProps> = (props): JSX.Element => {
    const {t, i18n} = useTranslation(['contract', 'app']);

    const { formData, onTextInputChange,onSelectInputChange, onRadioChange } = props;

    const [provinceOptions, setProvinceOptions] = useState<ISelectLabel[]>([]);
    const [stateOptions,setStateOptions] = useState<ISelectLabel[]>([]);
    const [stateOptionsFiscalRapresentative,setStateOptionsFiscalRapresentative] = useState<ISelectLabel[]>([]);

    const [splitOption, setSplitOption] = useState<IRadioButton[] | undefined>([
        { "id": "0", "label": t('general.yesLabel', {ns:'app'}), "value": "0" }, 
        { "id": "1", "label": t('general.noLabel', {ns:'app'}), "value": "1" }
    ]);

    useEffect(()=>{
        //Radio
        /*setSplitOption([
            { "id": "0", "label": t('general.yesLabel', {ns:'app'}), "value": "0" }, 
            { "id": "1", "label": t('general.noLabel', {ns:'app'}), "value": "1" }
        ]);*/
    }, [i18n.language, t]);
    const cloneArray = (arr: ISelectLabel[]) => arr.map(item => ({ ...item }));
    const updateStateProvince = () => {
        const isIT = i18n.language === 'it';
        const rawCountryArray = isIT ? myCountryArraySelect : myCountryArraySelectEN;
    
        // Business
        if (formData.businessState === '') {
            const businessStates = cloneArray(rawCountryArray);
            dsDeselectHandler(businessStates);
            setStateOptions(businessStates);
        } else {
            const businessStates = cloneArray(rawCountryArray);
            const selectedState = businessStates.find(s => s.id === formData.businessState);
            if (selectedState) dsSelectHandler(businessStates, selectedState);
            setStateOptions(businessStates);
    
            const updatedProvinces = provinceMap[formData.businessState] || provinceMap['default'];
            const provincesClone = cloneArray(updatedProvinces);
            const selectedProvince = provincesClone.find(p => p.id === formData.businessProvince);
            if (selectedProvince) dsSelectHandler(provincesClone, selectedProvince);
            setProvinceOptions(provincesClone);
        }
    
        // Tax Agent
        if (formData.taxAgentState === '') {
            const taxStates = cloneArray(rawCountryArray);
            dsDeselectHandler(taxStates);
            setStateOptionsFiscalRapresentative(taxStates);
        } else {
            const taxStates = cloneArray(rawCountryArray);
            const selectedState = taxStates.find(s => s.id === formData.taxAgentState);
            if (selectedState) dsSelectHandler(taxStates, selectedState);
            setStateOptionsFiscalRapresentative(taxStates);
        }
    };

    useEffect(()=>{
        updateStateProvince();
    },[])
    useEffect(()=>{
        updateStateProvince();
    },[i18n.language])



    return (

        <>
            {formData.clientType !== "" && <>
                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.1', {ns:'contract'})+" *"}//}//"Nome Società"
                                inputValue={formData.businessName}
                                inputName="businessName"
                                inputId="businessName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.1', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.2', {ns:'contract'})+" *"}//"Ragione Sociale"
                                inputValue={formData.businessSecondName}
                                inputName="businessSecondName"
                                inputId="businessSecondName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.2', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.14', {ns:'contract'})+"*"}//"Business code"
                                inputValue={formData.businessCode}
                                inputName="businessCode"
                                inputId="businessCode"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.14', {ns:'contract'})+""}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.3', {ns:'contract'})+" *"}//"Indirizzo Aziendale"
                                inputValue={formData.businessAddress}
                                inputName="businessAddress"
                                inputId="businessAddress"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.3', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={2}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.4', {ns:'contract'})+" *"}//"Civico"
                                inputValue={formData.businessStreetNumber}
                                inputName="businessStreetNumber"
                                inputId="businessStreetNumber"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.4', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={true} //STRINGTOONLYNUMBER
                                isReadonly={false}
                                maxDecimalDigits={0}
                                onInputChange={onTextInputChange}
                                minValue={0}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.5', {ns:'contract'})+" *"}//"Città"
                                inputValue={formData.businessCity}
                                inputName="businessCity"
                                inputId="businessCity"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.5', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    
                    
                </Row>
                <Row>
                <Col xs={12} md={2}>
                        <div className="textInputWrapper">
                            <Select
                                id={'id-select-nation'}
                                menuPlaceholder={t('customer.customerForm.sections.info.fields.8', {ns:'contract'}) + " *"} // "Paese"
                                hasIcon={false}
                                menuOptions={stateOptions}
                                menuLabel={t('customer.customerForm.sections.info.fields.8', {ns:'contract'}) + " *"} // "Paese"
                                menuId="select-id"
                                isDisabled={false}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    //console.log(event)
                                    const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(stateOptions!, selection);

                                    //aggiorna province
                                    const updatedProvinces = provinceMap[selection.value!] || provinceMap["default"];
                                    dsDeselectHandler(updatedProvinces)
                                    setProvinceOptions(updatedProvinces);

                                    // Pulisci il valore della provincia (stringa vuota)
                                    if (JSON.stringify(updatedProvinces) !== JSON.stringify(provinceOptions)) {
                                        onSelectInputChange({ detail: { option: { value: '' } } } as unknown as CustomEvent, "businessProvince");
                                    }
                
                                    onSelectInputChange(event,"businessState")
                                }}
                            ></Select>
                        </div>
                    </Col>
                    <Col xs={12} md={2}>
                        <div className="textInputWrapper">
                            {/*<TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.6', {ns:'contract'})+" *"}//"Provicia"
                                inputValue={formData.businessProvince}
                                inputName="businessProvince"
                                inputId="businessProvince"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder=""
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />*/}
                            <Select
                                id="id-select-province"
                                menuPlaceholder={t('customer.customerForm.sections.info.fields.6', { ns: 'contract' }) + " *"} // "Provincia"
                                menuOptions={provinceOptions} // Opzioni province dinamiche
                                menuLabel={t('customer.customerForm.sections.info.fields.6', { ns: 'contract' }) + " *"} // "Provincia"
                                isDisabled={provinceOptions.length === 0} // Disabilita il menu se non ci sono province
                                onOptionSelection={(event: Event) => {
                                    const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(provinceOptions!, selection);
                                    onSelectInputChange(event, "businessProvince")
                                }}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={2}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.7', {ns:'contract'})+" *"}//"Cap"
                                inputValue={formData.businessPostalCode}
                                inputName="businessPostalCode"
                                inputId="businessPostalCode"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.7', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={true} //STRINGTOONLYNUMBER
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                                minValue={0}
                                maxDecimalDigits={0}
                            />
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.9', {ns:'contract'})+" *"}//"Email aziendale"
                                inputValue={formData.businessEmail}
                                inputName="businessEmail"
                                inputId="businessEmail"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.9', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.10', {ns:'contract'})+" *"}//"Pec"
                                inputValue={formData.billingPec}
                                inputName="billingPec"
                                inputId="billingPec"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.10', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    {formData.clientType === ClientType.IT && <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.11', {ns:'contract'})+" *"}//"INIPEC"
                                inputValue={formData.inipec}
                                inputName="inipec"
                                inputId="inipec"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.11', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>}
                    {formData.clientType !== ClientType.IT && <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.13', {ns:'contract'})+" *"}//"Email fatturazione"
                                inputValue={formData.billingEmail}
                                inputName="billingEmail"
                                inputId="billingEmail"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.13', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>}
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.info.fields.12', {ns:'contract'})+" *"}//"Codice destinatario"
                                inputValue={formData.recipientCode}
                                inputName="recipientCode"
                                inputId="recipientCode"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.info.fields.12', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <p className="pageSemiSubTitle">{t('customer.customerForm.sections.fiscalData.title', {ns:'contract'})}</p>
                    </Col>
                </Row>

                {formData.clientType === ClientType.IT && <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalData.fields.0', {ns:'contract'})+" *"}//"Codice fiscale"
                                inputValue={formData.fiscalCode}
                                inputName="fiscalCode"
                                inputId="fiscalCode"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalData.fields.0', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalData.fields.1', {ns:'contract'})+" *"}//"Partita Iva"
                                inputValue={formData.vat}
                                inputName="vat"
                                inputId="vat"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalData.fields.1', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                </Row>}

                {formData.clientType !== ClientType.IT && <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalData.fields.4', {ns:'contract'})+" *"}//"Partita Iva CEE"
                                inputValue={formData.vatCee}
                                inputName="vatCee"
                                inputId="vatCee"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalData.fields.4', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalData.fields.5', {ns:'contract'})+" *"}//"Partita Iva Extra CEE"
                                inputValue={formData.vatExtrCee}
                                inputName="vatExtrCee"
                                inputId="vatExtrCee"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalData.fields.5', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                </Row>}


                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalData.fields.2', {ns:'contract'})}//"Gruppo Iva"
                                inputValue={formData.vatGroup}
                                inputName="vatGroup"
                                inputId="vatGroup"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalData.fields.2', {ns:'contract'})}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="radioButtonGroupWrapper" style={{gap:"12px"}}>
                            <label>
                                {/*Cliente in regime di split payment*/}
                                {t('customer.customerForm.sections.fiscalData.fields.3', {ns:'contract'})}
                            </label>
                            <RadiobuttonList
                                radioListData={splitOption ? splitOption : []}
                                radioListName="Radio List"
                                radioListDisabled={false}
                                selectedRadioID={formData.splitPayment ? "0" : "1"}
                                radioListOrientation="horizontal"
                                onRadioChange={onRadioChange}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <p className="pageSemiSubTitle">
                            {t('customer.customerForm.sections.fiscalRepr.title', {ns:'contract'})}
                        </p>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalRepr.fields.0', {ns:'contract'})}//"Denominazione"
                                inputValue={formData.taxAgentDenomination}
                                inputName="taxAgentDenomination"
                                inputId="taxAgentDenomination"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalRepr.fields.0', {ns:'contract'})}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalRepr.fields.1', {ns:'contract'})}//"Partita Iva"
                                inputValue={formData.taxAgentVat}
                                inputName="taxAgentVat"
                                inputId="taxAgentVat"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalRepr.fields.1', {ns:'contract'})}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalRepr.fields.2', {ns:'contract'})}//"Nome"
                                inputValue={formData.taxAgentFirstName}
                                inputName="taxAgentFirstName"
                                inputId="taxAgentFirstName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalRepr.fields.2', {ns:'contract'})}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalRepr.fields.3', {ns:'contract'})}//"Cognome"
                                inputValue={formData.taxAgentSecondName}
                                inputName="taxAgentSecondName"
                                inputId="taxAgentSecondName"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalRepr.fields.3', {ns:'contract'})}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            {/*<TextInput
                                inputLabel={t('customer.customerForm.sections.fiscalRepr.fields.4', {ns:'contract'})}//"Paese"
                                inputValue={formData.taxAgentState}
                                inputName="taxAgentState"
                                inputId="taxAgentState"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.fiscalRepr.fields.4', {ns:'contract'})}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />*/}
                            <Select
                                id={'id-select-nation1'}
                                menuPlaceholder={t('customer.customerForm.sections.info.fields.8', {ns:'contract'}) + " *"} // "Paese"
                                hasIcon={false}
                                menuOptions={stateOptionsFiscalRapresentative}
                                menuLabel={t('customer.customerForm.sections.info.fields.8', {ns:'contract'}) + " *"} // "Paese"
                                menuId="select-id1"
                                isDisabled={false}
                                selectStatus="default"
                                onOptionSelection={(event: Event) => {
                                    //console.log(event)
                                    const selection: ISelectLabel = (event as CustomEvent).detail.option;
                                    dsSelectHandler(stateOptionsFiscalRapresentative!, selection);
                                    onSelectInputChange(event,"taxAgentState")
                                }}
                            ></Select>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <p className="pageSemiSubTitle">
                            {t('customer.customerForm.sections.bank.title', {ns:'contract'})}
                        </p>
                    </Col>
                </Row>

                <Row>
                    <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.bank.fields.0', {ns:'contract'})+" *"}//"Codice Iban"
                                inputValue={formData.bankIban}
                                inputName="bankIban"
                                inputId="bankIban"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.bank.fields.0', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>
                    {formData.clientType === ClientType.EXTRA_UE && <Col xs={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.bank.fields.1', {ns:'contract'}) + " *"}//"Paese"
                                inputValue={formData.bankState}
                                inputName="bankState"
                                inputId="bankState"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.bank.fields.1', {ns:'contract'}) + " *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>}
                </Row>

                <Row>
                    {formData.clientType === ClientType.EXTRA_UE && <Col sm={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.bank.fields.2', {ns:'contract'})+ " *"}//"Conto Corrente"
                                inputValue={formData.bankAccount}
                                inputName="bankAccount"
                                inputId="bankAccount"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.bank.fields.2', {ns:'contract'})+ " *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>}
                    {formData.clientType !== ClientType.IT && <Col sm={12} md={4}>
                        <div className="textInputWrapper">
                            <TextInput
                                inputLabel={t('customer.customerForm.sections.bank.fields.3', {ns:'contract'})+" *"}//"Swift"
                                inputValue={formData.bankSwift}
                                inputName="bankSwift"
                                inputId="bankSwift"
                                inputDescription=""
                                inputStatus="default"
                                inputPlaceholder={t('customer.customerForm.sections.bank.fields.3', {ns:'contract'})+" *"}
                                isDisabled={false}
                                input-event-type="single_character"
                                isNumberVariant={false}
                                isReadonly={false}
                                onInputChange={onTextInputChange}
                            />
                        </div>
                    </Col>}
                </Row>

            </>}

        </>

    )
}
export default CustomerFormDataInput;